import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '../utils/propStyles';

const LoadingOverlayWrapper = styled<any, any>('div')`
    ${propStyles};
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding-top: 30vh;
`;

LoadingOverlayWrapper.defaultProps = {
    bgColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: 'popover',
};

export const LoadingOverlay: React.SFC<any> = ({
    theme,
    children,
    ...props
}) => (
    <LoadingOverlayWrapper {...props} {...theme.LoadingOverlay}>
        {children}
    </LoadingOverlayWrapper>
);

export default observer(withTheme(LoadingOverlay)) as any;



// WEBPACK FOOTER //
// ./src/Components/LoadingOverlay.tsx